/**
 * Groups Wunsch-Los line items in the cart and the drawer.
 */
(() => {
  const formatMoney = (cents) => {
    const fmt = window.formatMoneyDE || window.Kl24EuroFormat?.formatMoneyDE;
    if (fmt) return fmt(cents);
    const value = Math.max(0, Number(cents) || 0) / 100;
    const amount = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
    return `${amount}\u00A0€`;
  };

  const groupTable = (tbody) => {
    if (!tbody) return;
    const rows = [...tbody.querySelectorAll('tr.cart-item[data-wunsch-los]')];
    const signature = rows
      .map((row) => `${row.getAttribute('data-wunsch-los')}:${row.getAttribute('data-line-cents')}:${row.getAttribute('data-original-cents')}`)
      .join(',');
    if (tbody.dataset.wunschSig === signature) return;
    tbody.dataset.wunschSig = signature;
    tbody.querySelectorAll('[data-wunsch-los-header]').forEach((row) => row.remove());
    const groups = new Map();
    tbody.querySelectorAll('tr.cart-item[data-wunsch-los]').forEach((row) => {
      const id = row.getAttribute('data-wunsch-los');
      if (!id) return;
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push(row);
    });
    groups.forEach((rows, id) => {
      const first = rows[0];
      const label = first.getAttribute('data-wunsch-los-label') || 'Wunsch-Los';
      let finalSum = 0;
      let originalSum = 0;
      rows.forEach((row) => {
        const finalCents = Number(row.getAttribute('data-line-cents')) || 0;
        const originalCents = Number(row.getAttribute('data-original-cents')) || finalCents;
        finalSum += finalCents;
        originalSum += originalCents;
        row.classList.add('wunsch-los-card');
      });
      const header = document.createElement('tr');
      header.className = 'wunsch-los-header';
      header.dataset.wunschLosHeader = id;
      const cell = document.createElement('td');
      cell.colSpan = 6;
      const title = document.createElement('p');
      title.className = 'wunsch-los-header__title';
      title.textContent = label;
      const price = document.createElement('p');
      price.className = 'wunsch-los-header__price';
      price.textContent = `Einzelpreise ${formatMoney(originalSum || finalSum)}`;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'wunsch-los-header__toggle';
      toggle.textContent = 'Karten anzeigen';
      toggle.setAttribute('aria-expanded', 'false');
      rows.forEach((row) => row.classList.add('is-collapsed'));
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        toggle.textContent = open ? 'Karten anzeigen' : 'Karten verbergen';
        rows.forEach((row) => row.classList.toggle('is-collapsed', open));
      });
      cell.append(title, price, toggle);
      header.append(cell);
      first.before(header);
      const last = rows[rows.length - 1];
      if (last) last.classList.add('wunsch-los-card--group-end');
    });
  };

  const run = () => {
    document.querySelectorAll('table.cart-items tbody, #CartDrawer-CartItems tbody, cart-drawer tbody').forEach(groupTable);
  };

  let framing = false;
  const schedule = () => {
    if (framing) return;
    framing = true;
    window.requestAnimationFrame(() => {
      try {
        run();
      } finally {
        framing = false;
      }
    });
  };

  const watch = (node) => {
    if (!node || node.dataset.wunschLosWatch === '1') return;
    node.dataset.wunschLosWatch = '1';
    const observer = new MutationObserver(schedule);
    observer.observe(node, { childList: true, subtree: true });
  };

  const boot = () => {
    run();
    document.querySelectorAll('cart-drawer, #main-cart-items, .cart__items').forEach(watch);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('cart:refresh', schedule);
})();
